function popupBox(params) {
	var defaults = { width: 640, top: 100, height: false, prefix: false, callBack: '', needFrame: true};
	this.options = $.extend({}, defaults, params);
	this.options.margin = parseInt(this.options.width/2);
}

popupBox.prototype.openBox = function(data)
{
	if(!this.options.prefix){
		this.options.prefix = this.getPrefix(0,9999);
	}

	$('body').append('<div class="bg_overlay" id="' + this.options.prefix + '_bg_overlay"></div>');
	$('#' + this.options.prefix + '_bg_overlay').height($('body').height());

	if(this.options.width.toString().substr(-1,1) != '%')
		this.options.width = this.options.width.toString() + 'px';

	if(this.options.top && this.options.top.toString().substr(-1,1) != '%')
		this.options.top = this.options.top.toString() + 'px';

	if(this.options.margin && this.options.margin.toString().substr(-1,1) != '%')
		this.options.margin = this.options.margin.toString() + 'px';

	var height = '';
	if(this.options.height)
	{
		if(this.options.height.toString().substr(-1,1) != '%')
			this.options.height = this.options.height.toString() + 'px';

		height = 'height: '+this.options.height.toString()+';';
	}else{
		height = '';
	}

	var app = '';
	app += '<div class="panel" id="' + this.options.prefix + '_overlay" style="width: ' + this.options.width + ';'+height+' margin-top: ' + this.options.top + '; margin-left: -' + this.options.margin + '">';
	app += '<span class="float-right cursor-pointer mini-space glyphicon glyphicon-remove" id="' + this.options.prefix + '_close" title="Close"></span>';
	app += '<div class="default-padding" id="' + this.options.prefix + '_loading"><div align="center">Loading</div></div></div>';
	$('body').append(app);

	if(data)
		this.fillBox(data);

	var that = this;
	$('#' + this.options.prefix + '_bg_overlay, #' + this.options.prefix + '_close').click(function(){
		that.closePopup();
	});

	return false;
};

popupBox.prototype.getPrefix = function(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

popupBox.prototype.fillBox = function(data)
{
	$('#' + this.options.prefix + '_loading').html(data);
	$('#' + this.options.prefix + '_frame').height($('#' + this.options.prefix + '_loading').height());
};

popupBox.prototype.closePopup = function()
{
	if(this.options.callBack)
		eval(this.options.callBack)();

	$('#' + this.options.prefix + '_bg_overlay').remove();
	$('#' + this.options.prefix + '_frame').remove();
	$('#' + this.options.prefix + '_overlay').remove();
	return false;
};

popupBox.prototype.destroyPopup = function(){
	$('#' + this.options.prefix + '_frame').remove();
	$('#' + this.options.prefix + '_close').remove();
	$('#' + this.options.prefix + '_overlay').remove();
	$('#' + this.options.prefix + '_loading').remove();
	$('#' + this.options.prefix + '_bg_overlay').remove();
	return false;
};

popupBox.prototype.getPrefix = function(min, max)
{
	return Math.floor(Math.random() * (max - min + 1)) + min;
};